import {baseBackendUrl} from "../shared/constants";
import {message} from "antd";

export async function fetchTeams() {
    const token = localStorage.getItem("token");
    const response = await fetch(`${baseBackendUrl}/teams`, { headers: { Authorization: `Bearer ${token}` } });
    if (!response.ok) throw new Error("Ошибка получения данных");
    const data = await response.json();
    return Array.isArray(data) ? data : [];
}

export async function fetchIndividuals() {
    const token = localStorage.getItem("token");
    try {
        const response = await fetch(`${baseBackendUrl}/teams/individuals`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        if (!response.ok) {
            console.error("Ошибка загрузки участников:");
            return [];
        }
        const data = await response.json();
        return Array.isArray(data) ? data : [];
    } catch (error) {
        message.error("Ошибка загрузки участников");
        return [];
    }
}

export async function fetchTeamMembers(codegroup) {
    const token = localStorage.getItem("token");
    try {
        const response = await fetch(`${baseBackendUrl}/teams/members`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({ codegroup }),
        });
        const data = await response.json();
        return data;
    } catch (error) {
        message.error("Ошибка загрузки данных команды");
        return [];
    }
}

export async function addTeam(teamData) {
    const token = localStorage.getItem("token");
    const response = await fetch(`${baseBackendUrl}/teams`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(teamData),
    });
    if (!response.ok) throw new Error("Ошибка добавления команды");
    return response.json();
}

export async function updateTeam(id, teamData) {
    const token = localStorage.getItem("token");
    const response = await fetch(`${baseBackendUrl}/teams/${id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(teamData),
    });
    if (!response.ok) throw new Error("Ошибка обновления команды");
    return response.json();
}

export async function deleteTeam(id) {
    const token = localStorage.getItem("token");
    const response = await fetch(`${baseBackendUrl}/teams/${id}`, {
        method: 'DELETE',
        headers: {
            Authorization: `Bearer ${token}`
        },
    });
    if (!response.ok) throw new Error("Ошибка удаления команды");
    return response.json();
}

export async function loadIndividuals() {
    const token = localStorage.getItem("token");
    const response = await fetch(`${baseBackendUrl}/teams/individuals`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response.json();
}

export async function loadUsersList() {
    const token = localStorage.getItem("token");
    const usersList = await fetch(`${baseBackendUrl}/admin-tools`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    }).then(res => res.json());
    return usersList;
}

export async function saveIndividual(currentParticipant) {
    const token = localStorage.getItem("token");
    const method = currentParticipant?.id ? "PUT" : "POST";
    const url = currentParticipant?.id
        ? `${baseBackendUrl}/teams/individual/${currentParticipant.id}`
        : `${baseBackendUrl}/teams/individual`;
    await fetch(url, {
        method,
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(currentParticipant),
    });
    message.success("Данные сохранены!");
}

export async function deleteIndividual(id) {
    const token = localStorage.getItem("token");
    await fetch(`${baseBackendUrl}/teams/individual/${id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}`},
    });
    message.success("Участник удалён!");
}